import{breakpoints as breakpointsInternal}from"@jutro/layout/internal";export const breakpoints=breakpointsInternal;